import { Navigate, type RouteObject } from 'react-router-dom';

export const dashboardRoutes: RouteObject[] = [
    { path: '/service-plans/dashboard', element: <Navigate to="/agreements" replace /> },
    { path: '/service-plans/search', element: <Navigate to="/agreements" replace /> },
];
